(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-base-bracelet"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const selectors = {
      productInfo: 'product-info[id^="MainProduct"]',
      braceletItem: '.base-bracelet__item[data-handle]',
    };

    const setLoadingState = (section, isLoading) => {
      if (!section) return;
      section.style.opacity = isLoading ? '0.5' : '1';
      section.style.pointerEvents = isLoading ? 'none' : 'auto';
      section.classList.toggle('is-loading', isLoading);
    };

    const fetchSectionHtml = async ({ productUrl, sectionId }) => {
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('sections', sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const data = await response.json();
      const html = data[sectionId];
      if (!html) throw new Error('Section HTML missing');
      return html;
    };

    const swapProductInfo = (currentSection, html) => {
      localStorage.removeItem('selectedCharms');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const replacement = doc.querySelector(selectors.productInfo);
      if (!replacement) throw new Error('Replacement product-info not found');
      currentSection.replaceWith(replacement);
      return document.querySelector(selectors.productInfo);
    };

    const initBaseBracelet = (productInfoSection) => {
      if (!productInfoSection) return;

      const braceletItems = productInfoSection.querySelectorAll(selectors.braceletItem);
      const currentHandle = productInfoSection.dataset.productHandle;
      const sectionId =
        productInfoSection.dataset.sectionId || productInfoSection.dataset.section || productInfoSection.id;

      if (!sectionId || braceletItems.length === 0) return;

      const allBraceletItems = productInfoSection.querySelectorAll('.base-bracelet__item');
      allBraceletItems.forEach((item) => item.classList.remove('is-active'));

      const setActiveByHandle = (handle) => {
        const root = document.querySelector(selectors.productInfo);
        if (!root) return;
        const items = root.querySelectorAll('.base-bracelet__item');
        items.forEach((item) => item.classList.remove('is-active'));
        for (const item of items) {
          if (item.dataset.handle === handle) {
            item.classList.add('is-active');
            break;
          }
        }
      };

      const setActiveItem = (activeItem) => {
        braceletItems.forEach((item) => {
          item.classList.toggle('is-active', item === activeItem);
        });
      };

      setTimeout(() => setActiveByHandle(currentHandle), 0);

      braceletItems.forEach((item) => {
        if (item.dataset.baseBraceletBound === 'true') return;
        item.dataset.baseBraceletBound = 'true';

        item.addEventListener('click', async (e) => {
          e.preventDefault();
          const productHandle = item.dataset.handle;
          let productUrl = item.dataset.url || `/products/${productHandle}`;

          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('charm-builder') === 'true' || urlParams.get('charm_builder') === 'true') {
            const separator = productUrl.includes('?') ? '&' : '?';
            productUrl = `${productUrl}${separator}charm-builder=true`;
          }

          if (!productHandle || !productUrl) return;

          setActiveItem(item);
          setLoadingState(productInfoSection, true);

          try {
            const sectionHtml = await fetchSectionHtml({ productUrl, sectionId });
            const newSection = swapProductInfo(productInfoSection, sectionHtml);

            window.history.pushState({ handle: productHandle, url: productUrl }, '', productUrl);

            if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (typeof ProductModel !== 'undefined' && typeof ProductModel.loadShopifyXR === 'function') {
              ProductModel.loadShopifyXR();
            }

            initBaseBracelet(newSection);
            setActiveByHandle(productHandle);

            if (typeof window.initCharmTabs === 'function') {
              window.initCharmTabs();
            }
            if (typeof window.attachCharmPropertiesToForm === 'function') {
              window.attachCharmPropertiesToForm();
            }
            if (typeof window.initCharmBuilderView === 'function') {
              window.initCharmBuilderView(newSection);
            }

            setLoadingState(newSection, false);
            newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (err) {
            console.error('Error loading product via base bracelet:', err);
            window.location.href = productUrl;
          } finally {
            const current = document.querySelector(selectors.productInfo);
            setLoadingState(current, false);
          }
        });
      });
    };

    window.initBaseBraceletSelector = initBaseBracelet;
    initBaseBracelet(document.querySelector(selectors.productInfo));

    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.url) {
        window.location.href = e.state.url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-base-chain"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const selectors = {
      productInfo: 'product-info[id^="MainProduct"]',
      chainItem: '.base-chain__item[data-handle]',
    };

    const setLoadingState = (section, isLoading) => {
      if (!section) return;
      section.style.opacity = isLoading ? '0.5' : '1';
      section.style.pointerEvents = isLoading ? 'none' : 'auto';
      section.classList.toggle('is-loading', isLoading);
    };

    const fetchSectionHtml = async ({ productUrl, sectionId }) => {
      // Properly construct URL with query parameters
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('sections', sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = await response.json();
      const html = data[sectionId];
      if (!html) {
        throw new Error('Section HTML missing from response');
      }
      return html;
    };

    const swapProductInfo = (currentSection, html) => {
      // Clear only the 'selectedCharms' key
      localStorage.removeItem('selectedCharms');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const replacement = doc.querySelector(selectors.productInfo);
      if (!replacement) {
        throw new Error('Replacement product-info not found');
      }
      currentSection.replaceWith(replacement);
      return document.querySelector(selectors.productInfo);
    };

    const initBaseChain = (productInfoSection) => {
      if (!productInfoSection) return;

      const chainItems = productInfoSection.querySelectorAll(selectors.chainItem);
      const currentHandle = productInfoSection.dataset.productHandle;
      const sectionId =
        productInfoSection.dataset.sectionId || productInfoSection.dataset.section || productInfoSection.id;

      if (!sectionId) return;

      // Clear all active states first before checking what should be active
      const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
      const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
      allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
      allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

      if (chainItems.length === 0) {
        // Even if no base-chain items, try to initialize semi-precious if it exists
        if (typeof window.initSemiPreciousSelector === 'function') {
          window.initSemiPreciousSelector(productInfoSection);
        }
        return;
      }

      const setActiveItem = (activeItem) => {
        // Remove active class from all base-chain items
        chainItems.forEach((item) => {
          item.classList.toggle('is-active', item === activeItem);
        });
        // Remove active class from all semi-precious items
        const productInfoSection =
          activeItem.closest('product-info[id^="MainProduct"]') || document.querySelector(selectors.productInfo);
        if (productInfoSection) {
          const semiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
          semiPreciousItems.forEach((item) => {
            item.classList.remove('is-active');
          });
        }
      };

      const setActiveByHandle = (handle) => {
        const productInfoSection = document.querySelector(selectors.productInfo);
        if (!productInfoSection) return;

        // First, clear ALL active states from both selectors
        const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
        const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
        allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
        allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

        // Check base-chain items first (priority)
        // Find and activate only the first matching item to maintain visual position
        let baseChainMatch = false;
        for (const item of chainItems) {
          if (item.dataset.handle === handle) {
            item.classList.add('is-active');
            baseChainMatch = true;
            break; // Stop after first match to maintain position
          }
        }

        // Only check semi-precious if no base-chain match
        if (!baseChainMatch) {
          for (const item of allSemiPreciousItems) {
            if (item.dataset.handle === handle) {
              item.classList.add('is-active');
              break; // Stop after first match to maintain position
            }
          }
        }
      };

      // Set initial active state based on current product handle
      // Use setTimeout to ensure this runs after any other initializations
      setTimeout(() => {
        setActiveByHandle(currentHandle);
      }, 0);

      chainItems.forEach((item) => {
        if (item.dataset.baseChainBound === 'true') return;
        item.dataset.baseChainBound = 'true';

        item.addEventListener('click', async (event) => {
          event.preventDefault();

          const productHandle = item.dataset.handle;
          let productUrl = item.dataset.url || `/products/${productHandle}`;

          // Check if current URL has charm-builder parameter and preserve it (support both formats)
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('charm-builder') === 'true' || urlParams.get('charm_builder') === 'true') {
            const separator = productUrl.includes('?') ? '&' : '?';
            productUrl = `${productUrl}${separator}charm-builder=true`;
          }

          if (!productHandle || !productUrl) return;

          setActiveItem(item);
          setLoadingState(productInfoSection, true);

          try {
            const sectionHtml = await fetchSectionHtml({ productUrl, sectionId });
            const newSection = swapProductInfo(productInfoSection, sectionHtml);

            window.history.pushState({ handle: productHandle, url: productUrl }, '', productUrl);

            if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (typeof ProductModel !== 'undefined' && typeof ProductModel.loadShopifyXR === 'function') {
              ProductModel.loadShopifyXR();
            }

            // Re-initialize semi-precious selector first (so it clears its active state)
            if (typeof window.initSemiPreciousSelector === 'function') {
              window.initSemiPreciousSelector(newSection);
            }

            // Then initialize base-chain
            initBaseChain(newSection);

            // Set active state after both selectors are initialized
            // Use setTimeout to ensure DOM is ready
            setTimeout(() => {
              const productInfoSection = document.querySelector(selectors.productInfo);
              if (!productInfoSection) return;

              // Clear all active states
              const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
              const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
              allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
              allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

              // Check base-chain items first (priority)
              // Find and activate only the first matching item to maintain visual position
              let baseChainMatch = false;
              for (const item of allBaseChainItems) {
                if (item.dataset.handle === productHandle) {
                  item.classList.add('is-active');
                  baseChainMatch = true;
                  break; // Stop after first match to maintain position
                }
              }

              // Only set semi-precious active if no base-chain match
              if (!baseChainMatch) {
                for (const item of allSemiPreciousItems) {
                  if (item.dataset.handle === productHandle) {
                    item.classList.add('is-active');
                    break; // Stop after first match to maintain position
                  }
                }
              }
            }, 0);

            // Re-initialize charm tabs after section reload
            if (typeof window.initCharmTabs === 'function') {
              window.initCharmTabs();
            }

            // Re-attach charm properties to form after section reload
            if (typeof window.attachCharmPropertiesToForm === 'function') {
              window.attachCharmPropertiesToForm();
            }

            // Re-initialize charm builder view mode based on URL parameter
            if (typeof window.initCharmBuilderView === 'function') {
              window.initCharmBuilderView(newSection);
            }

            setLoadingState(newSection, false);
            newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (error) {
            console.error('Error loading product via base chain:', error);
            window.location.href = productUrl;
          } finally {
            const current = document.querySelector(selectors.productInfo);
            setLoadingState(current, false);
          }
        });
      });
    };

    // Make initBaseChain globally accessible
    window.initBaseChainSelector = initBaseChain;

    initBaseChain(document.querySelector(selectors.productInfo));

    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.url) {
        window.location.href = event.state.url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-character-customization"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
      const customizationBlocks = document.querySelectorAll('[data-character-add-to-cart]');

      customizationBlocks.forEach(function (block) {
        const popup = block.closest('popup-component');
        if (!popup) return;

        const countButtons = popup.querySelectorAll('[data-character-count]');
        const inputsSection = popup.querySelector('[data-character-inputs-section]');
        const fontSelect = popup.querySelector('[data-character-font]');
        const qtyInput = popup.querySelector('[data-character-qty]');
        const addToCartBtn = popup.querySelector('[data-character-add-to-cart]');
        const productFormId = addToCartBtn.dataset.productFormId;
        const productForm = document.getElementById(productFormId);
        const previewGrid = popup.querySelector('[data-character-preview-grid]');
        const uniqueId = '{{ unique_id }}';

        if (!productForm) return;

        let selectedCount = 3; // Default to 3 characters
        let characterInputs = [];

        // Create input fields based on selected count
        function createInputFields(count) {
          // Clear existing inputs
          if (inputsSection) {
            inputsSection.innerHTML = '';
          }
          if (previewGrid) {
            previewGrid.innerHTML = '';
          }
          characterInputs = [];

          for (let i = 1; i <= count; i++) {
            // Create input wrapper
            const inputWrapper = document.createElement('div');
            inputWrapper.className = 'character-customization-modal__input-wrapper';

            // Create label
            const label = document.createElement('label');
            label.setAttribute('for', `character-${uniqueId}-${i}`);
            label.className = 'character-customization-modal__label';
            label.textContent = `Character ${i}`;

            // Create input
            const input = document.createElement('input');
            input.type = 'text';
            input.id = `character-${uniqueId}-${i}`;
            input.className = 'character-customization-modal__input';
            input.maxLength = 1;
            input.setAttribute('data-character-index', i);
            input.setAttribute('data-character-input', '');
            input.placeholder = 'Enter character';

            // Create character count
            const charCount = document.createElement('span');
            charCount.className = 'character-customization-modal__char-count';
            charCount.innerHTML = '<span data-char-remaining>1</span> Characters left';

            inputWrapper.appendChild(label);
            inputWrapper.appendChild(input);
            inputWrapper.appendChild(charCount);

            if (inputsSection) {
              inputsSection.appendChild(inputWrapper);
            }

            characterInputs.push(input);

            // Create preview character
            if (previewGrid) {
              const previewChar = document.createElement('div');
              previewChar.className = 'character-customization-modal__preview-char';
              previewChar.setAttribute('data-character-preview-char', '');
              previewChar.setAttribute('data-position', i);
              previewChar.textContent = '';
              previewGrid.appendChild(previewChar);
            }
          }

          // Set up input listeners
          characterInputs.forEach(function (input, index) {
            const previewChar = previewGrid ? previewGrid.querySelector(`[data-position="${index + 1}"]`) : null;

            input.addEventListener('input', function (e) {
              // Only allow single character
              let value = e.target.value;
              if (value.length > 1) {
                value = value.charAt(0);
                e.target.value = value;
              }

              // Update preview
              if (previewChar) {
                previewChar.textContent = value.toUpperCase() || '';
                previewChar.style.fontFamily = fontSelect ? fontSelect.value : 'Helvetica';
              }

              // Update character count
              const charRemaining = input.parentElement.querySelector('[data-char-remaining]');
              if (charRemaining) {
                const remaining = 1 - value.length;
                charRemaining.textContent = remaining;
                if (charRemaining.parentElement) {
                  charRemaining.parentElement.textContent = remaining + ' Characters left';
                }
              }
            });

            input.addEventListener('keypress', function (e) {
              // Only allow alphanumeric and basic symbols
              const char = String.fromCharCode(e.which);
              if (!/[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(char)) {
                e.preventDefault();
              }
            });
          });
        }

        // Update preview font when font changes
        if (fontSelect) {
          fontSelect.addEventListener('change', function () {
            const previewChars = previewGrid ? previewGrid.querySelectorAll('[data-character-preview-char]') : [];
            previewChars.forEach(function (char) {
              char.style.fontFamily = fontSelect.value;
            });
          });
        }

        // Character count button selection
        countButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            countButtons.forEach(function (b) {
              b.classList.remove('character-customization-modal__count-btn--active');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('character-customization-modal__count-btn--active');
            btn.setAttribute('aria-pressed', 'true');
            selectedCount = parseInt(btn.dataset.characterCount);
            createInputFields(selectedCount);
          });
        });

        // Quantity controls
        const qtyMinus = popup.querySelector('[data-qty-minus]');
        const qtyPlus = popup.querySelector('[data-qty-plus]');

        if (qtyMinus && qtyInput) {
          qtyMinus.addEventListener('click', function () {
            const current = parseInt(qtyInput.value) || 1;
            if (current > 1) {
              qtyInput.value = current - 1;
            }
          });
        }

        if (qtyPlus && qtyInput) {
          qtyPlus.addEventListener('click', function () {
            const current = parseInt(qtyInput.value) || 1;
            qtyInput.value = current + 1;
          });
        }

        // Add to cart functionality
        addToCartBtn.addEventListener('click', function () {
          const characters = [];
          characterInputs.forEach(function (input) {
            const value = input.value.trim();
            if (value) {
              characters.push(value);
            }
          });

          const characterString = characters.join('');
          const characterFont = fontSelect ? fontSelect.value : '';
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

          // Remove existing character property inputs
          const existingInputs = productForm.querySelectorAll('[data-character-property]');
          existingInputs.forEach(function (input) {
            input.remove();
          });

          // Add character properties as hidden inputs to the product form
          if (characterString) {
            const textPropertyInput = document.createElement('input');
            textPropertyInput.type = 'hidden';
            textPropertyInput.name = 'properties[Character Customization]';
            textPropertyInput.value = characterString;
            textPropertyInput.setAttribute('data-character-property', 'text');
            productForm.appendChild(textPropertyInput);

            // Also add individual characters
            characters.forEach(function (char, index) {
              const charInput = document.createElement('input');
              charInput.type = 'hidden';
              charInput.name = `properties[Character ${index + 1}]`;
              charInput.value = char;
              charInput.setAttribute('data-character-property', `char-${index + 1}`);
              productForm.appendChild(charInput);
            });
          }

          const fontInput = document.createElement('input');
          fontInput.type = 'hidden';
          fontInput.name = 'properties[Character Font]';
          fontInput.value = characterFont;
          fontInput.setAttribute('data-character-property', 'font');
          productForm.appendChild(fontInput);

          const countInput = document.createElement('input');
          countInput.type = 'hidden';
          countInput.name = 'properties[Character Count]';
          countInput.value = selectedCount;
          countInput.setAttribute('data-character-property', 'count');
          productForm.appendChild(countInput);

          // Update quantity in the main form if there's a quantity input
          const formQtyInput = productForm.querySelector('input[name="quantity"]');
          if (formQtyInput) {
            formQtyInput.value = quantity;
          } else {
            const qtyPropertyInput = document.createElement('input');
            qtyPropertyInput.type = 'hidden';
            qtyPropertyInput.name = 'quantity';
            qtyPropertyInput.value = quantity;
            productForm.appendChild(qtyPropertyInput);
          }

          // Trigger form submission by clicking the add to cart button
          const submitButton = productForm.querySelector('[data-add-to-cart], button[type="submit"][name="add"]');
          if (submitButton && !submitButton.disabled) {
            // Add loading state
            addToCartBtn.classList.add('is-loading');
            addToCartBtn.disabled = true;

            // Click the submit button to trigger the theme's cart add functionality
            submitButton.click();

            // Close popup after a short delay to allow form processing
            setTimeout(function () {
              const closeBtn = popup.querySelector('[data-popup-close]');
              if (closeBtn) {
                closeBtn.click();
              }
            }, 500);
          } else {
            // Fallback: try form submission directly
            if (productForm.checkValidity()) {
              productForm.requestSubmit();
            } else {
              productForm.reportValidity();
              addToCartBtn.classList.remove('is-loading');
              addToCartBtn.disabled = false;
            }
          }
        });

        // Reset form when popup opens
        const popupOpenBtn = popup.querySelector('[data-popup-open]');
        if (popupOpenBtn) {
          popupOpenBtn.addEventListener('click', function () {
            // Initialize with default count
            selectedCount = 3;
            createInputFields(selectedCount);

            // Reset font
            if (fontSelect) fontSelect.selectedIndex = 0;
            if (qtyInput) qtyInput.value = '1';

            // Reset count buttons to 3 characters
            countButtons.forEach(function (btn) {
              if (btn.dataset.characterCount === '3') {
                btn.classList.add('character-customization-modal__count-btn--active');
                btn.setAttribute('aria-pressed', 'true');
              } else {
                btn.classList.remove('character-customization-modal__count-btn--active');
                btn.setAttribute('aria-pressed', 'false');
              }
            });

            // Reset button state
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.disabled = false;
          });
        }

        // Initialize on load
        createInputFields(selectedCount);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-engraving"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
      const engravingBlocks = document.querySelectorAll('[data-engraving-add-to-cart]');

      engravingBlocks.forEach(function (block) {
        const popup = block.closest('popup-component');
        if (!popup) return;

        const textInput = popup.querySelector('[data-engraving-text]');
        const fontSelect = popup.querySelector('[data-engraving-font]');
        const qtyInput = popup.querySelector('[data-engraving-qty]');
        const charCount = popup.querySelector('[data-char-count]');
        const charRemaining = popup.querySelector('[data-char-remaining]');
        const fontSizeButtons = popup.querySelectorAll('[data-font-size]');
        const addToCartBtn = popup.querySelector('[data-engraving-add-to-cart]');
        const productFormId = addToCartBtn.dataset.productFormId;
        const productForm = document.getElementById(productFormId);
        const previewText = popup.querySelector('[data-engraving-preview-text]');

        if (!productForm) return;

        let selectedFontSize = 'standard';

        // Character limits based on font size
        const charLimits = {
          small: 15,
          standard: 10,
          large: 5,
        };

        // Get max characters based on current font size
        function getMaxChars() {
          return charLimits[selectedFontSize] || 10;
        }

        // Update character count
        function updateCharCount() {
          if (!textInput || !charRemaining) return;
          const maxChars = getMaxChars();
          const remaining = maxChars - (textInput.value.length || 0);
          if (charRemaining) {
            charRemaining.textContent = remaining;
          }
          if (charRemaining && charRemaining.parentElement) {
            charRemaining.parentElement.textContent = remaining + ' Characters left';
          }
        }

        // Update maxlength attribute and character count
        function updateCharLimit() {
          const maxChars = getMaxChars();
          if (textInput) {
            textInput.setAttribute('maxlength', maxChars);
            // Trim text if it exceeds new limit
            if (textInput.value.length > maxChars) {
              textInput.value = textInput.value.substring(0, maxChars);
            }
          }
          if (charRemaining) {
            updateCharCount();
          }
        }

        // Update preview function
        function updatePreview() {
          if (!previewText) return;

          const text = textInput ? textInput.value : '';
          const font = fontSelect ? fontSelect.value : 'Helvetica';

          previewText.textContent = text || '';
          previewText.style.fontFamily = font;
          previewText.setAttribute('data-font-size', selectedFontSize);

          // Hide preview if no text
          const preview = popup.querySelector('[data-engraving-preview]');
          if (preview) {
            preview.style.display = text ? 'flex' : 'none';
          }
        }

        // Set up text input listeners
        if (textInput) {
          // Update preview and character count on every input
          textInput.addEventListener('input', function () {
            if (charRemaining) {
              updateCharCount();
            }
            updatePreview();
          });

          // Initialize character limit
          if (charRemaining) {
            updateCharLimit();
          }
        }

        // Font size button selection
        fontSizeButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            fontSizeButtons.forEach(function (b) {
              b.classList.remove('engraving-modal__font-size-btn--active');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('engraving-modal__font-size-btn--active');
            btn.setAttribute('aria-pressed', 'true');
            selectedFontSize = btn.dataset.fontSize;
            if (charRemaining) {
              updateCharLimit();
            }
            updatePreview();
          });
        });

        // Font selection change
        if (fontSelect) {
          fontSelect.addEventListener('change', function () {
            updatePreview();
          });
        }

        // Quantity controls
        const qtyMinus = popup.querySelector('[data-qty-minus]');
        const qtyPlus = popup.querySelector('[data-qty-plus]');

        if (qtyMinus && qtyInput) {
          qtyMinus.addEventListener('click', function () {
            const current = parseInt(qtyInput.value) || 1;
            if (current > 1) {
              qtyInput.value = current - 1;
            }
          });
        }

        if (qtyPlus && qtyInput) {
          qtyPlus.addEventListener('click', function () {
            const current = parseInt(qtyInput.value) || 1;
            qtyInput.value = current + 1;
          });
        }

        // Add to cart functionality
        addToCartBtn.addEventListener('click', function () {
          const engravingText = textInput ? textInput.value.trim() : '';
          const engravingFont = fontSelect ? fontSelect.value : '';
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

          // Remove existing engraving property inputs
          const existingInputs = productForm.querySelectorAll('[data-engraving-property]');
          existingInputs.forEach(function (input) {
            input.remove();
          });

          // Add engraving properties as hidden inputs to the product form
          if (engravingText) {
            const textPropertyInput = document.createElement('input');
            textPropertyInput.type = 'hidden';
            textPropertyInput.name = 'properties[Engraving Text]';
            textPropertyInput.value = engravingText;
            textPropertyInput.setAttribute('data-engraving-property', 'text');
            productForm.appendChild(textPropertyInput);
          }

          const sizeInput = document.createElement('input');
          sizeInput.type = 'hidden';
          sizeInput.name = 'properties[Engraving Font Size]';
          sizeInput.value = selectedFontSize;
          sizeInput.setAttribute('data-engraving-property', 'size');
          productForm.appendChild(sizeInput);

          const fontInput = document.createElement('input');
          fontInput.type = 'hidden';
          fontInput.name = 'properties[Engraving Font]';
          fontInput.value = engravingFont;
          fontInput.setAttribute('data-engraving-property', 'font');
          productForm.appendChild(fontInput);

          // Update quantity in the main form if there's a quantity input
          const formQtyInput = productForm.querySelector('input[name="quantity"]');
          if (formQtyInput) {
            formQtyInput.value = quantity;
          } else {
            const qtyPropertyInput = document.createElement('input');
            qtyPropertyInput.type = 'hidden';
            qtyPropertyInput.name = 'quantity';
            qtyPropertyInput.value = quantity;
            productForm.appendChild(qtyPropertyInput);
          }

          // Trigger form submission by clicking the add to cart button
          const submitButton = productForm.querySelector('[data-add-to-cart], button[type="submit"][name="add"]');
          if (submitButton && !submitButton.disabled) {
            // Add loading state
            addToCartBtn.classList.add('is-loading');
            addToCartBtn.disabled = true;

            // Click the submit button to trigger the theme's cart add functionality
            submitButton.click();

            // Close popup after a short delay to allow form processing
            setTimeout(function () {
              const closeBtn = popup.querySelector('[data-popup-close]');
              if (closeBtn) {
                closeBtn.click();
              }
            }, 500);
          } else {
            // Fallback: try form submission directly
            if (productForm.checkValidity()) {
              productForm.requestSubmit();
            } else {
              productForm.reportValidity();
              addToCartBtn.classList.remove('is-loading');
              addToCartBtn.disabled = false;
            }
          }
        });

        // Reset form when popup opens
        const popupOpenBtn = popup.querySelector('[data-popup-open]');
        if (popupOpenBtn) {
          popupOpenBtn.addEventListener('click', function () {
            // Reset to defaults
            if (textInput) textInput.value = '';
            if (fontSelect) fontSelect.selectedIndex = 0;
            if (qtyInput) qtyInput.value = '1';

            // Reset font size to standard
            fontSizeButtons.forEach(function (btn) {
              if (btn.dataset.fontSize === 'standard') {
                btn.classList.add('engraving-modal__font-size-btn--active');
                btn.setAttribute('aria-pressed', 'true');
                selectedFontSize = 'standard';
              } else {
                btn.classList.remove('engraving-modal__font-size-btn--active');
                btn.setAttribute('aria-pressed', 'false');
              }
            });

            // Reset character limit
            if (charRemaining) {
              updateCharLimit();
            }

            // Reset preview
            updatePreview();

            // Reset button state
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.disabled = false;
          });
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-semi-precious"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const selectors2 = {
      productInfo: 'product-info[id^="MainProduct"]',
      chainItem: '.semi-precious__item[data-handle]',
    };

    const setLoadingState = (section, isLoading) => {
      if (!section) return;
      section.style.opacity = isLoading ? '0.5' : '1';
      section.style.pointerEvents = isLoading ? 'none' : 'auto';
      section.classList.toggle('is-loading', isLoading);
    };

    const fetchSectionHtml = async ({ productUrl, sectionId }) => {
      // Properly construct URL with query parameters
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('sections', sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = await response.json();
      const html = data[sectionId];
      if (!html) {
        throw new Error('Section HTML missing from response');
      }
      return html;
    };

    const swapProductInfo = (currentSection, html) => {
      // Clear only the 'selectedCharms' key
      localStorage.removeItem('selectedCharms');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const replacement = doc.querySelector(selectors2.productInfo);
      if (!replacement) {
        throw new Error('Replacement product-info not found');
      }
      currentSection.replaceWith(replacement);
      return document.querySelector(selectors2.productInfo);
    };

    const initSemiPrecious = (productInfoSection) => {
      if (!productInfoSection) return;

      const chainItems = productInfoSection.querySelectorAll(selectors2.chainItem);
      const currentHandle = productInfoSection.dataset.productHandle;
      const sectionId =
        productInfoSection.dataset.sectionId || productInfoSection.dataset.section || productInfoSection.id;

      if (!sectionId) return;

      // Clear all active states first before checking what should be active
      const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
      const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
      allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
      allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

      if (chainItems.length === 0) {
        // Even if no semi-precious items, try to initialize base-chain if it exists
        if (typeof window.initBaseChainSelector === 'function') {
          window.initBaseChainSelector(productInfoSection);
        }
        return;
      }

      const setActiveItem = (activeItem) => {
        // Remove active class from all semi-precious items
        chainItems.forEach((item) => {
          item.classList.toggle('is-active', item === activeItem);
        });
        // Remove active class from all base-chain items
        const productInfoSection =
          activeItem.closest('product-info[id^="MainProduct"]') || document.querySelector(selectors2.productInfo);
        if (productInfoSection) {
          const baseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
          baseChainItems.forEach((item) => {
            item.classList.remove('is-active');
          });
        }
      };

      const setActiveByHandle = (handle) => {
        const productInfoSection = document.querySelector(selectors2.productInfo);
        if (!productInfoSection) return;

        // First, clear ALL active states from both selectors
        const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
        const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
        allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
        allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

        // Check base-chain items first (they have priority)
        // Find and activate only the first matching item to maintain visual position
        let baseChainMatch = false;
        for (const item of allBaseChainItems) {
          if (item.dataset.handle === handle) {
            item.classList.add('is-active');
            baseChainMatch = true;
            break; // Stop after first match to maintain position
          }
        }

        // Only set semi-precious active if no base-chain match
        if (!baseChainMatch) {
          for (const item of chainItems) {
            if (item.dataset.handle === handle) {
              item.classList.add('is-active');
              break; // Stop after first match to maintain position
            }
          }
        }
      };

      // Set initial active state based on current product handle
      // Use setTimeout to ensure this runs after any other initializations
      setTimeout(() => {
        setActiveByHandle(currentHandle);
      }, 0);

      chainItems.forEach((item) => {
        if (item.dataset.semiPreciousBound === 'true') return;
        item.dataset.semiPreciousBound = 'true';

        item.addEventListener('click', async (event) => {
          event.preventDefault();

          const productHandle = item.dataset.handle;
          let productUrl = item.dataset.url || `/products/${productHandle}`;

          // Check if current URL has charm-builder parameter and preserve it (support both formats)
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('charm-builder') === 'true' || urlParams.get('charm_builder') === 'true') {
            const separator = productUrl.includes('?') ? '&' : '?';
            productUrl = `${productUrl}${separator}charm-builder=true`;
          }

          if (!productHandle || !productUrl) return;

          setActiveItem(item);
          setLoadingState(productInfoSection, true);

          try {
            const sectionHtml = await fetchSectionHtml({ productUrl, sectionId });
            const newSection = swapProductInfo(productInfoSection, sectionHtml);

            window.history.pushState({ handle: productHandle, url: productUrl }, '', productUrl);

            if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (typeof ProductModel !== 'undefined' && typeof ProductModel.loadShopifyXR === 'function') {
              ProductModel.loadShopifyXR();
            }

            // Re-initialize base-chain selector first (so it clears its active state)
            if (typeof window.initBaseChainSelector === 'function') {
              window.initBaseChainSelector(newSection);
            }

            // Then initialize semi-precious
            initSemiPrecious(newSection);

            // Set active state after both selectors are initialized
            // Use setTimeout to ensure DOM is ready
            setTimeout(() => {
              const productInfoSection = document.querySelector(selectors2.productInfo);
              if (!productInfoSection) return;

              // Clear all active states
              const allBaseChainItems = productInfoSection.querySelectorAll('.base-chain__item');
              const allSemiPreciousItems = productInfoSection.querySelectorAll('.semi-precious__item');
              allBaseChainItems.forEach((item) => item.classList.remove('is-active'));
              allSemiPreciousItems.forEach((item) => item.classList.remove('is-active'));

              // Check base-chain items first (priority)
              // Find and activate only the first matching item to maintain visual position
              let baseChainMatch = false;
              for (const item of allBaseChainItems) {
                if (item.dataset.handle === productHandle) {
                  item.classList.add('is-active');
                  baseChainMatch = true;
                  break; // Stop after first match to maintain position
                }
              }

              // Only set semi-precious active if no base-chain match
              if (!baseChainMatch) {
                for (const item of allSemiPreciousItems) {
                  if (item.dataset.handle === productHandle) {
                    item.classList.add('is-active');
                    break; // Stop after first match to maintain position
                  }
                }
              }
            }, 0);

            // Re-initialize charm tabs after section reload
            if (typeof window.initCharmTabs === 'function') {
              window.initCharmTabs();
            }

            // Re-attach charm properties to form after section reload
            if (typeof window.attachCharmPropertiesToForm === 'function') {
              window.attachCharmPropertiesToForm();
            }

            // Re-initialize charm builder view mode based on URL parameter
            if (typeof window.initCharmBuilderView === 'function') {
              window.initCharmBuilderView(newSection);
            }

            setLoadingState(newSection, false);
            newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (error) {
            console.error('Error loading product via base chain:', error);
            window.location.href = productUrl;
          } finally {
            const current = document.querySelector(selectors2.productInfo);
            setLoadingState(current, false);
          }
        });
      });
    };

    // Make initSemiPrecious globally accessible
    window.initSemiPreciousSelector = initSemiPrecious;

    initSemiPrecious(document.querySelector(selectors2.productInfo));

    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.url) {
        window.location.href = event.state.url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
